import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doctorsAPI } from '../api';
import toast from 'react-hot-toast';
import { Search, Eye, Trash2, ChevronLeft, ChevronRight } from 'lucide-react';

const StatusBadge = ({ status }) => {
    const map = {
        Active: 'badge-success',
        Inactive: 'badge-warning',
        Suspended: 'badge-danger',
    };
    return (
        <span className={`badge ${map[status] || 'badge-gray'}`}>{status}</span>
    );
};

export default function Doctors() {
    const navigate = useNavigate();
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState('');
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const limit = 10;

    const fetchDoctors = () => {
        setLoading(true);
        doctorsAPI
            .getAll({ page, limit, search, status })
            .then((res) => {
                setDoctors(res.data.data.doctors);
                setTotal(res.data.data.total);
            })
            .catch(() => toast.error('Failed to load doctors'))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchDoctors();
    }, [page, status]);
    useEffect(() => {
        const t = setTimeout(() => {
            setPage(1);
            fetchDoctors();
        }, 400);
        return () => clearTimeout(t);
    }, [search]);

    const handleDelete = async (id, name) => {
        if (!window.confirm(`Delete Dr. ${name}?`)) return;
        try {
            await doctorsAPI.delete(id);
            toast.success('Doctor deleted');
            fetchDoctors();
        } catch {
            toast.error('Failed to delete');
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            await doctorsAPI.updateStatus(id, newStatus);
            toast.success('Status updated');
            fetchDoctors();
        } catch {
            toast.error('Failed to update status');
        }
    };

    const pages = Math.ceil(total / limit);

    return (
        <div className="fade-in">
            <div className="page-header">
                <div>
                    <h1 className="page-title">Doctors</h1>
                    <p className="page-subtitle">
                        {total} total doctors registered
                    </p>
                </div>
            </div>

            <div className="filters">
                <div className="search-bar" style={{ flex: 1, maxWidth: 340 }}>
                    <Search size={16} />
                    <input
                        className="input"
                        placeholder="Search by name, email, specialization..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <select
                    className="input"
                    value={status}
                    onChange={(e) => {
                        setStatus(e.target.value);
                        setPage(1);
                    }}
                >
                    <option value="">All Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Delete">Delete</option>
                </select>
            </div>

            <div className="card" style={{ padding: 0 }}>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>Doctor</th>
                                <th>Specialization</th>
                                <th>Contact</th>
                                <th>Education</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={7}>
                                        <div className="loading-container">
                                            <div className="spinner" />
                                        </div>
                                    </td>
                                </tr>
                            ) : doctors.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan={7}
                                        style={{
                                            textAlign: 'center',
                                            color: 'var(--text3)',
                                            padding: 60,
                                        }}
                                    >
                                        No doctors found
                                    </td>
                                </tr>
                            ) : (
                                doctors.map((doc) => (
                                    <tr key={doc.doctor_id}>
                                        <td>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 12,
                                                }}
                                            >
                                                <div className="avatar">
                                                    {(doc.full_name || 'D')[0]}
                                                </div>
                                                <div>
                                                    <div
                                                        style={{
                                                            color: 'var(--text)',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        {doc.full_name}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: 12,
                                                            color: 'var(--text3)',
                                                        }}
                                                    >
                                                        {doc.profile_id}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{doc.specialization}</td>
                                        <td>
                                            <div style={{ fontSize: 13 }}>
                                                {doc.email}
                                                {doc.mobile_number}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: 12,
                                                    color: 'var(--text3)',
                                                }}
                                            >
                                                {doc.country_code}{' '}
                                                {doc.mobile_number}
                                            </div>
                                        </td>
                                        <td>
                                            <span className="tag">
                                                {doc.education}
                                            </span>
                                        </td>
                                        {/* <td>
                                            {doc.interested_modes ===
                                                'Online Only' && (
                                                <div style={{ fontSize: 12 }}>
                                                    For Online: ₹
                                                    {doc.online_fees}
                                                </div>
                                            )}
                                            {doc.interested_modes ===
                                                'Home Visit' && (
                                                <div style={{ fontSize: 12 }}>
                                                    For Home: ₹{doc.home_fees}
                                                </div>
                                            )}
                                            {doc.interested_modes ===
                                                'Both' && (
                                                <>
                                                    <div
                                                        style={{ fontSize: 12 }}
                                                    >
                                                        For Online: ₹
                                                        {doc.online_fees}
                                                    </div>
                                                    <div
                                                        style={{ fontSize: 12 }}
                                                    >
                                                        For Home: ₹
                                                        {doc.home_fees}
                                                    </div>
                                                </>
                                            )}
                                        </td> */}
                                        <td>
                                            <select
                                                value={doc.status}
                                                onChange={(e) =>
                                                    handleStatusChange(
                                                        doc.doctor_id,
                                                        e.target.value
                                                    )
                                                }
                                                style={{
                                                    background:
                                                        'var(--surface2)',
                                                    border: '1px solid var(--border)',
                                                    borderRadius: 8,
                                                    color: 'var(--text)',
                                                    fontSize: 13,
                                                    padding: '4px 8px',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <option value="Active">
                                                    Active
                                                </option>
                                                <option value="Inactive">
                                                    Inactive
                                                </option>
                                                <option value="Suspended">
                                                    Suspended
                                                </option>
                                            </select>
                                        </td>
                                        <td>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: 8,
                                                }}
                                            >
                                                <button
                                                    className="btn btn-ghost btn-sm"
                                                    onClick={() =>
                                                        navigate(
                                                            `/doctors/${doc.doctor_id}`
                                                        )
                                                    }
                                                >
                                                    <Eye size={14} />
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() =>
                                                        handleDelete(
                                                            doc.doctor_id,
                                                            doc.full_name
                                                        )
                                                    }
                                                >
                                                    <Trash2 size={14} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {pages > 1 && (
                    <div
                        style={{
                            padding: '16px 20px',
                            borderTop: '1px solid var(--border)',
                        }}
                    >
                        <div className="pagination">
                            <button
                                className="page-btn"
                                onClick={() => setPage((p) => p - 1)}
                                disabled={page === 1}
                            >
                                <ChevronLeft size={14} />
                            </button>
                            {Array.from(
                                { length: Math.min(pages, 5) },
                                (_, i) => i + 1
                            ).map((p) => (
                                <button
                                    key={p}
                                    className={`page-btn ${page === p ? 'active' : ''}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            ))}
                            <button
                                className="page-btn"
                                onClick={() => setPage((p) => p + 1)}
                                disabled={page === pages}
                            >
                                <ChevronRight size={14} />
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
